var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ticket-star",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.98,
    height: 14,
    viewBox: "0 0 13.98 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "ticket-star_Frame_Background_",
    "data-name": "ticket-star [Frame Background]",
    width: 13.98,
    height: 14,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_ticket-star",
    "data-name": "vuesax/bold/ticket-star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ticket-star-2",
    "data-name": "ticket-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.645,3.121V6.376c0,2.392-.728,3.121-3.116,3.121H4.6V7.735a.408.408,0,1,0-.816,0V9.5H3.111C.81,9.5.053,8.808,0,6.656a.4.4,0,0,1,.116-.292.391.391,0,0,1,.291-.122,1.493,1.493,0,0,0,0-2.987.382.382,0,0,1-.291-.122A.4.4,0,0,1,0,2.841C.053.688.81,0,3.111,0h.676V1.762a.408.408,0,1,0,.816,0V0H8.528c2.388,0,3.116.729,3.116,3.121ZM9.67,4.323a.353.353,0,0,0-.291-.245l-.746-.111a.068.068,0,0,1-.064-.047l-.332-.677a.349.349,0,0,0-.32-.2.364.364,0,0,0-.326.2l-.332.677a.116.116,0,0,1-.07.047l-.746.111a.344.344,0,0,0-.291.245.359.359,0,0,0,.093.367l.542.525A.1.1,0,0,1,6.81,5.3l-.128.741a.365.365,0,0,0,.146.356.349.349,0,0,0,.21.07.344.344,0,0,0,.169-.041l.67-.35a.1.1,0,0,1,.082,0l.67.35a.364.364,0,0,0,.524-.385L9.023,5.3a.083.083,0,0,1,.023-.082l.542-.525a.335.335,0,0,0,.082-.367Z",
    transform: "translate(1.17 2.252)",
    fill: "#4258bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H13.98V14H0Z",
    fill: "#4258bf",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketStar);
export default __webpack_public_path__ + "static/media/ticket-star.421f45a7d5140f24d7d9098325b63673.svg";
export { ForwardRef as ReactComponent };